function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "person",
  transform: "translate(-4.166 12.365)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11607",
  "data-name": "Path 11607",
  d: "M29.25,31.5a2.2,2.2,0,0,0,2.25-2.25c0-2.25-2.25-9-13.5-9S4.5,27,4.5,29.25A2.2,2.2,0,0,0,6.75,31.5ZM6.761,29.376v0ZM6.8,29.25H29.2l.032-.005.018,0A6.007,6.007,0,0,0,27.378,25.5c-1.467-1.466-4.228-3-9.378-3s-7.911,1.53-9.378,3A6.025,6.025,0,0,0,6.75,29.241Zm22.442.126v0ZM18,15.75a4.5,4.5,0,1,0-4.5-4.5A4.5,4.5,0,0,0,18,15.75Zm6.75-4.5A6.75,6.75,0,1,1,18,4.5,6.75,6.75,0,0,1,24.75,11.25Z",
  fill: "#fff",
  fillRule: "evenodd"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "bx-message-alt",
  d: "M12.83,3H5.541A1.042,1.042,0,0,0,4.5,4.041v6.247A1.042,1.042,0,0,0,5.541,11.33H7.408l1.777,1.777,1.777-1.777H12.83a1.042,1.042,0,0,0,1.041-1.041V4.041A1.042,1.042,0,0,0,12.83,3Zm0,7.289h-2.3L9.186,11.635,7.839,10.289h-2.3V4.041H12.83Z",
  transform: "matrix(0.966, -0.259, 0.259, 0.966, -5.123, 3.024)",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "bx-message-alt-2",
  "data-name": "bx-message-alt",
  d: "M16.016,3H5.94A1.441,1.441,0,0,0,4.5,4.44v8.637a1.441,1.441,0,0,0,1.44,1.44H8.521l2.457,2.457,2.457-2.457h2.581a1.441,1.441,0,0,0,1.44-1.44V4.44A1.441,1.441,0,0,0,16.016,3Zm0,10.077H12.839l-1.861,1.861L9.117,13.077H5.94V4.44H16.016Z",
  transform: "matrix(0.966, 0.259, -0.259, 0.966, 14.815, -4.062)",
  fill: "#fff"
});

var SvgUserMessage = function SvgUserMessage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user-message",
    width: 30.9,
    height: 43.865,
    viewBox: "0 0 30.9 43.865",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserMessage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-message.c393a82e.svg";
export { ForwardRef as ReactComponent };